module.exports = __webpack_public_path__ + "img/2b9eea2.jpg";